let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("heSmI")).then(() => parcelRequire('7p1sh'));